import { render, staticRenderFns } from "./ApplyMod.vue?vue&type=template&id=63b1b6c4&scoped=true"
import script from "./ApplyMod.vue?vue&type=script&lang=js"
export * from "./ApplyMod.vue?vue&type=script&lang=js"
import style0 from "./ApplyMod.vue?vue&type=style&index=0&id=63b1b6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1b6c4",
  null
  
)

export default component.exports